export default "__VITE_ASSET__yhHM6ogK__"